import {
  IScenarioFolder,
  normalizeScenarioFolder,
  ScenarioFolderServer
} from 'shared/entities/scenarioFolder';

export default class ScenarioFolderModel implements IScenarioFolder {
  readonly id: string;
  readonly dateCreated: Date;
  readonly dateUpdated: Date;

  private _title: string;

  constructor({ id, title, dateCreated, dateUpdated }: IScenarioFolder) {
    this.id = id;
    this._title = title;
    this.dateCreated = dateCreated;
    this.dateUpdated = dateUpdated;
  }

  get title() {
    return this._title;
  }

  updateTitle = (value: string) => {
    this._title = value;
  };

  static fromJson(raw: ScenarioFolderServer): ScenarioFolderModel {
    return new ScenarioFolderModel(normalizeScenarioFolder(raw));
  }
}
